export enum ErrorTypes {
  TECHNICAL_ERROR = 'TECHNICAL_ERROR',
  ACCESS_ERROR = 'ACCESS_ERROR',
  RESOURCE_ERROR = 'RESOURCE_ERROR',
  INPUT_ERROR = 'INPUT_ERROR',
}
